module.exports = __webpack_public_path__ + "static/media/ARF-0001_big.6158e4b7.png";